import { render, staticRenderFns } from "./VehiclesList.vue?vue&type=template&id=71588b5f&scoped=true&"
import script from "./VehiclesList.vue?vue&type=script&lang=ts&"
export * from "./VehiclesList.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesList.vue?vue&type=style&index=0&id=71588b5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71588b5f",
  null
  
)

export default component.exports